import React from "react";
import * as FaIcons from "react-icons/fa";

export const AdminSideBarData = [
        {
            title: "Used Vehicles",
            path: "/page/UsedVehicles",
            icon: < FaIcons.FaCaravan / >,
         },
         {
            title: "Print Single Label",
            path: "/page/FindAndPrint",
            icon: < FaIcons.FaSearch / >,
          },
         {
             title: "Settings",
             path: "/page/Settings",
             icon: < FaIcons.FaWhmcs / >,
          },
          {
              title: "Order Supplies",
              path: "/page/orderSupplies",
              icon: < FaIcons.FaToolbox / >,
          },
          {
              title: "Contacts",
              path: "/page/contacts",
              icon: < FaIcons.FaAddressCard / >,
          },
          {
              title: "Print History",
              path: "/page/history",
              icon: < FaIcons.FaAddressCard / >,
          },
       ];

